/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Skip_ButtonInputs */

const en_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No thanks`)
};

const fr_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non merci`)
};

const de_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein danke`)
};

const it_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, grazie`)
};

const ru_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет, спасибо`)
};

const es_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, gracias`)
};

const zh_cn2_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不用了`)
};

const ja_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信しない`)
};

const hi_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं, धन्यवाद`)
};

const pt_pt2_explorer_assignment_email_skip_button = /** @type {(inputs: Explorer_Assignment_Email_Skip_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, obrigado`)
};

/**
* | output |
* | --- |
* | "No thanks" |
*
* @param {Explorer_Assignment_Email_Skip_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_skip_button = /** @type {((inputs?: Explorer_Assignment_Email_Skip_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Skip_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_assignment_email_skip_button(inputs)
	if (locale === "de") return de_explorer_assignment_email_skip_button(inputs)
	if (locale === "it") return it_explorer_assignment_email_skip_button(inputs)
	if (locale === "ru") return ru_explorer_assignment_email_skip_button(inputs)
	if (locale === "es") return es_explorer_assignment_email_skip_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_assignment_email_skip_button(inputs)
	if (locale === "ja") return ja_explorer_assignment_email_skip_button(inputs)
	if (locale === "hi") return hi_explorer_assignment_email_skip_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_assignment_email_skip_button(inputs)
	return en_explorer_assignment_email_skip_button(inputs)
});